import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { loadIcon } from "@odin/assets";
import { defineComponent, computed, watch, h } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
const cache = {};
const defaultIcon = '<rect x="20%" y="20%" stroke="#555" fill="none" width="60%" height="60%"/>';
const _sfc_main = defineComponent({
  name: "WsIcon",
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: void 0
    },
    size: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: 16
    },
    width: {
      type: Number,
      default: 16
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  emits: ["loaded", "unloaded", "error"],
  // eslint-disable-next-line max-lines-per-function
  setup(props, vm) {
    const svgElSource = ref(null);
    const classes = computed(() => {
      const classes2 = ["ws-icon"];
      if (vm.attrs.class) {
        classes2.push(vm.attrs.class);
      }
      if (props.color) {
        classes2.push("text-" + props.color);
      }
      if (props.circle) {
        classes2.push("ws-icon--circle");
      }
      return classes2.join(" ");
    });
    const styles = computed(() => {
      let height;
      let width;
      if (props.size) {
        height = props.size.toString();
        width = props.size.toString();
      } else {
        height = props.height;
        width = props.width;
      }
      return [
        `
      height: ${height}px;
      min-height: ${height}px;
      width: ${width}px;
      min-width: ${width}px;
     `,
        vm.attrs.style
      ];
    });
    const filterAttrs = (attrs) => {
      return Object.keys(attrs).reduce((result, key) => {
        if (attrs[key] !== false && attrs[key] !== null && attrs[key] !== void 0) {
          result[key] = attrs[key];
        }
        return result;
      }, {});
    };
    const getSvgAttrs = (svgEl) => {
      const svgAttrs = {
        class: classes.value,
        title: props.name,
        style: styles.value,
        "data-test": `ws-icon-${props.name}`
      };
      if (svgEl) {
        const attrs = svgEl.attributes;
        if (!attrs) {
          return svgAttrs;
        }
        for (let i = attrs.length - 1; i >= 0; i--) {
          svgAttrs[attrs[i].name] = attrs[i].value;
        }
      }
      return svgAttrs;
    };
    const download = (name) => {
      return new Promise((resolve, reject) => {
        loadIcon(name).then((icon) => {
          const iconSvg = decodeURIComponent(icon.replace("data:image/svg+xml,", ""));
          try {
            const parser = new DOMParser();
            const result = parser.parseFromString(iconSvg, "text/xml");
            const svgEl = result.getElementsByTagName("svg")[0];
            if (svgEl) {
              resolve(svgEl);
            } else {
              reject(new Error('Loaded file is not valid SVG"'));
            }
          } catch (e) {
            reject(e);
          }
        });
      });
    };
    const getSource = (name) => {
      if (!cache[name]) {
        cache[name] = download(name);
      }
      cache[name].then((svg) => {
        svgElSource.value = svg;
      }).catch((err) => {
        delete cache[name];
        vm.emit("error", err);
      });
    };
    watch(() => props.name, () => {
      getSource(props.name);
    }, { immediate: true });
    return (vm2) => {
      return h(
        "svg",
        Object.assign(
          { innerHTML: svgElSource.value ? svgElSource.value.innerHTML : defaultIcon },
          // component attrs and listeners
          filterAttrs(vm2.$attrs),
          // source attrs
          getSvgAttrs(svgElSource.value)
        )
      );
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsIcon.vue.es2.js.map
